
import React from "react";
import { Link } from "react-router-dom";
import "./sitemap.css";

const Sitemap = () => {
  return (
    <div className="tk-sitemap-wrapper">
      {/* Premium Hero Banner Block */}
      <section className="tk-sitemap-hero clearfix">
        <div className="container-fluid tk-sitemap-fluid-container">
          <div className="tk-badge-sitemap">NAVIGATION HUB</div>
          <h2 className="tk-hero-main-title">
            Site Map
            <span className="tk-hero-subtitle">Checkout Our Site Map</span>
            <span className="tk-hero-lead-text">
              Easily navigate across our platform's structure, services, and organization network nodes.
            </span>
          </h2>
        </div>
      </section>

      {/* Main Structure Map Grid */}
      <section className="tk-sitemap-body pb-5">
        <div className="container tk-sitemap-container">
          <div className="row siteMap tk-grid-row">
            
            {/* Column 1: Corporate Infrastructure */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="tk-sitemap-card">
                <div className="tk-card-header-zone">
                  <span className="tk-card-icon">🏢</span>
                  <b className="tk-category-title">Company</b>
                </div>
                <ul className="tk-link-list">
                  <li><Link to="#">Home</Link></li>
                  <li><Link to="#">About Us</Link></li>
                  <li><Link to="#">Meet the Team</Link></li>
                  <li><Link to="#">Certification</Link></li>
                  <li><Link to="#">Careers</Link></li>
                  <li><Link to="#" className="tk-current-page">Site Map</Link></li>
                  <li><Link to="#">Contact Us</Link></li>
                  <li className="tk-highlight-li">
                    <Link to="#" target="_blank">Agent Login 🔐</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Column 2: Ecosystem Network */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="tk-sitemap-card">
                <div className="tk-card-header-zone">
                  <span className="tk-card-icon">🌐</span>
                  <b className="tk-category-title">Group Companies</b>
                </div>
                <ul className="tk-link-list">
                  <li>
                    <a href="#DMTkendra" className="tk-corporate-link">DMT EMPIRE INDIA PRIVATE LIMITED</a>
                  </li>
                  <li>
                    <a href="#finwelco">Finwelco</a>
                  </li>
                  <li>
                    <a href="#dmt">DMT MEDIA MARKETING</a>
                  </li>
                  <li>
                    <a href="#dmt">Couponfares</a>
                  </li>
                  <li>
                    <a href="#Shardajeet">Shardajeet Foundation</a>
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Column 3: Regional Distribution Nodes */}
            <div className="col-lg-4 col-md-12 mb-4">
              <div className="tk-sitemap-card tk-accent-card">
                <div className="tk-card-header-zone">
                  <span className="tk-card-icon">💼</span>
                  <b className="tk-category-title">Grahak Seva Kendra</b>
                </div>
                <ul className="tk-link-list">
                  <li>
                    <Link to="#" className="tk-bold-node">Grahak Seva Kendra Portal</Link>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;

// import React from "react";
// import "./sitemap.css";
// import { Link } from "react-router-dom";
// const Sitemap = () => {
//   return (
//     <>
//       <section className="OP_BannerS clearfix">
//         <div className="container-fluid">
//           <h2>
//             Site Map
//             <span>Checkout Our Site Map</span>
//             <span></span>
//           </h2>
//         </div>
//       </section>

//       <section className="services pb-5">
//         <div className="container">
//           <div className="row siteMap">
//             <div className="col-md-4">
//               <b>Company</b>
//               <ul>
//                 <li>
//                   <Link to="Default.aspx">Home</Link>
//                 </li>
//                 <li>
//                   <Link to="about.aspx">About Us</Link>
//                 </li>
//                 <li>
//                   <Link to="team.aspx">Meet the Team</Link>
//                 </li>
//                 <li>
//                   <Link to="Certification.aspx">Certification</Link>
//                 </li>
//                 <li>
//                   <Link to="Careers.aspx">Careers</Link>
//                 </li>
//                 <li>
//                   <Link to="SiteMap.aspx">Site Map</Link>
//                 </li>
//                 <li>
//                   <Link to="contact.aspx">Contact Us</Link>
//                 </li>
//                 <li>
//                   <Link to="https://services.dialmytrip.com">Agent Login</Link>
//                 </li>
//               </ul>
//             </div>
           
//             <div className="col-md-4">
//               <b>Group Companies</b>
//               <ul>
//                 <li>
//                   <a href="#DMTkendra">DMT EMPIRE INDIA PRIVATE LIMITED</a>
//                 </li>
//                 {/* <li>
//                   <a href="#Accountancy">Accountancy</a>
//                 </li>
//                 <li>
//                   <a href="#MediaMarketing">Media and Marketing</a>
//                 </li> */}
//                 <li>
//                   <a href="#finwelco">Finwelco</a>
//                 </li>
//                 <li>
//                   <a href="#Shardajeet">Shardajeet Foundation</a>
//                 </li>
//               </ul>
//             </div>
           
//             <div className="col-md-4">
//               <b>Grahak Seva Kendra</b>
//               <ul>
//                 <li>
//                   <Link to="#">Grahak Seva Kendra</Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Sitemap;
